import { FormElement } from '@uplift/types';
import { MultiSelect } from './multi-select';
import { Page } from './page';
import { ReviewPage } from './review-page';
import { SectionDivider } from './section-divider';
import { SingleSelect } from './single-select';
import { FormBuilderTextInput } from './text-input';

export type ElementRendererProps = {
  element: FormElement;
  isPreview: boolean;
  onSingleSelect: (value: string | null) => void;
};

export const ElementRenderer: React.VFC<ElementRendererProps> = ({ element, isPreview, onSingleSelect }) => {
  switch (element.formElementDefinition.formElementType) {
    case 'single_select':
    case 'scale':
      return <SingleSelect element={element} onClick={onSingleSelect} />;
    case 'multi_select':
      return <MultiSelect element={element} />;
    case 'simple_input':
      return <FormBuilderTextInput element={element} type="simple" />;
    case 'short_answer':
      return <FormBuilderTextInput element={element} type="free" />;
    case 'page':
      return <Page element={element} onClick={onSingleSelect} />;
    case 'review_page':
      return <ReviewPage isPreview={isPreview} />;
    case 'divider':
      return <SectionDivider element={element} />;
    default:
      console.error('Unknown element. ID', element.formElementId);
      return <div>Unknown element!</div>;
  }
};
